import { FileDisplayCard } from "../components/FileDisplayCard/index.js";
import "react";
import { Label, LightboxContextGroup } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
// src/modules/Files/shared/FilesListDisplay.tsx
var FilesListDisplay = ({ className, fileUrls, label, orientation = "horizontal" }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(className, "gap-y-xxs flex flex-col"),
		children: [label && /* @__PURE__ */ jsx(Label, { children: label }), /* @__PURE__ */ jsx(LightboxContextGroup, {
			files: fileUrls,
			children: orientation === "horizontal" ? /* @__PURE__ */ jsx("div", {
				className: "gap-xs inline-flex flex-wrap items-center",
				children: fileUrls.map((url) => /* @__PURE__ */ jsx(FileDisplayCard, { fileUrl: url }, url))
			}) : /* @__PURE__ */ jsx("div", {
				className: "gap-y-xs flex flex-col justify-center",
				children: fileUrls.map((url) => /* @__PURE__ */ jsx(FileDisplayCard, {
					fileUrl: url,
					orientation
				}, url))
			})
		})]
	});
};
export { FilesListDisplay };

//# sourceMappingURL=FilesListDisplay.js.map